import React from 'react'
import URI from 'URIjs'
import QuestionGame from '../services/QuestionGame'

export const VisibilityFilter = (props) => {

  const getUrl = (key, value) => props.url.clone().setQuery('puslapis', '1').setQuery(key, value)

  const logAndRedirect = (key, value) =>
    (() => {
      if (props.url) {
        QuestionGame.trackClick(`${key}-${value}`, () => {
          window.location = getUrl(key, value)
        })
      } else {
        window.showVipMembershipRequired();
      }
    })

  return <p>
    <strong>Rodomi:</strong>&nbsp;&nbsp;&nbsp;&nbsp;

    {props.currentView == 'Both'
      ? <span className="current">visi</span>
      : <a onClick={logAndRedirect('rodomi', 'visi')} className='underline'>visi</a>}&nbsp;|&nbsp;

    {props.currentView == 'VisibleVotes'
      ? <span className="current">tik atidengti</span>
      : <a onClick={logAndRedirect('rodomi', 'atidengti')} className='underline'>tik atidengti</a>}&nbsp;|&nbsp;

    {props.currentView == 'HiddenVotes'
      ? <span className="current">tik neatidengti</span>
      : <a onClick={logAndRedirect('rodomi', 'neatidengti')} className='underline'>tik neatidengti</a>}
  </p>
}

export const LocationFilter = (props) => {

  const getUrl = (key, value) => props.url.clone().setQuery('puslapis', '1').setQuery(key, value)

  const logAndRedirect = (key, value) =>
    (() => {
      if (props.url) {
        QuestionGame.trackClick(`${key}-${value}`, () => {
          window.location = getUrl(key, value)
        })
      } else {
        window.showVipMembershipRequired();
      }
    })

  const myLocation = props.locationName ? props.locationName : 'mano vietovė'

  return <p>
    <strong>Vietovė:</strong>&nbsp;&nbsp;&nbsp;&nbsp;

    {props.value == 'visos'
      ? <span className="current">visos</span>
      : <a onClick={logAndRedirect('vietove', 'visos')} className="underline">visos</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == 'manovietove'
      ? <span className="current">{myLocation}</span>
      : <a onClick={logAndRedirect('vietove', 'manovietove')} className="underline">{myLocation}</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == 'manovietove50'
      ? <span className="current">nariai 50 km spinduliu</span>
      : <a onClick={logAndRedirect('vietove', 'manovietove50')} className="underline">nariai 50 km spinduliu</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == 'lietuva'
      ? <span className="current">Lietuva</span>
      : <a onClick={logAndRedirect('vietove', 'lietuva')} className="underline">Lietuva</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == 'uzsienis'
      ? <span className="current">užsienis</span>
      : <a onClick={logAndRedirect('vietove', 'uzsienis')} className="underline">užsienis</a>}
  </p>
}

export const AgeFilter = (props) => {

  const getUrl = (key, value) => props.url.clone().setQuery('puslapis', '1').setQuery(key, value)

  const logAndRedirect = (key, value) =>
    (() => {
      if (props.url) {
        QuestionGame.trackClick(`${key}-${value}`, () => {
          window.location = getUrl(key, value)
        })
      } else {
        window.showVipMembershipRequired();
      }
    })


  const {younger, peers, older} = props

  return <p>
    <strong>Amžius:</strong>&nbsp;&nbsp;&nbsp;&nbsp;

    {props.value == '0'
      ? <span className="current">visi</span>
      : <a onClick={logAndRedirect('amzius', '0')} className="underline">visi</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == '1'
      ? <span className="current">{younger}</span>
      : <a onClick={logAndRedirect('amzius', '1')} className="underline">{younger}</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == '2'
      ? <span className="current">{peers}</span>
      : <a onClick={logAndRedirect('amzius', '2')} className="underline">{peers}</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == '3'
      ? <span className="current">{older}</span>
      : <a onClick={logAndRedirect('amzius', '3')} className="underline">{older}</a>}
  </p>
}

export const Sorting = (props) => {

  const getUrl = (key, value) => props.url.clone().setQuery('puslapis', '1').setQuery(key, value)

  const logAndRedirect = (key, value) =>
    (() => {
      if (props.url) {
        QuestionGame.trackClick(`${key}-${value}`, () => {
          window.location = getUrl(key, value)
        })
      } else {
        window.showVipMembershipRequired();
      }
    })

  return <p>
    <strong>Rūšiavimas:</strong>&nbsp;&nbsp;&nbsp;&nbsp;

    {props.value == '1'
      ? <span className="current">naujausi</span>
      : <a onClick={logAndRedirect('rusiavimas', '1')} className="underline">naujausi</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == '2'
      ? <span className="current">prisijungę</span>
      : <a onClick={logAndRedirect('rusiavimas', '2')} className="underline">prisijungę</a>}&nbsp;&nbsp;|&nbsp;&nbsp;

    {props.value == '3'
      ? <span className="current">populiariausi</span>
      : <a onClick={logAndRedirect('rusiavimas', '3')} className="underline">populiariausi</a>}
  </p>
}
